import {hookToAttributeSelector} from '@wix/panda-js-utils'
import {membersPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {isMobile} from '../../../../../../commons/selectors/environment'
import {useMembersPageActions, useMembersPageSelector} from '../../../hooks/runtime'
import {EventLink} from '../../styled-components/event-link'
import {CancelRsvpButtonProps} from './interfaces'

export const CancelRsvpButton = ({event}: CancelRsvpButtonProps) => {
  const {t} = useTranslation()
  const mobile = useMembersPageSelector(isMobile)
  const {openCancelRsvpModal} = useMembersPageActions()

  return (
    <EventLink
      secondary={true}
      mobile={mobile}
      onClick={() => openCancelRsvpModal({event, returnFocusElement: hookToAttributeSelector(DH.BUTTON_CANCEL_RSVP)})}
      data-hook={DH.BUTTON_CANCEL_RSVP}
    >
      {t('events.buttons.update-rsvp')}
    </EventLink>
  )
}
